import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// Keep the singleton independent of route components to avoid circular initialization.
export default new VueRouter({
  mode: 'history',
  base: '/',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})
